import React from 'react';
import { Box, Flex, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@shared/joykit/packages/core/common';
import { ThingToDoComponentProps, ThingToDoTile, useThingToDo } from './';
import { useTranslation } from '@shared/core';
import { useThingsToDoTelemetry } from './ThingsToDo.telemetry';
import { useColorPaletteProvider } from '@apps/guest/packages/layout-engine/layouts/ColorPaletteProvider/ColorPaletteProvider';

export const ThingToDoLink: React.FC<ThingToDoComponentProps> = ({ designType = 'fullRow', ...props }) => {
  const telemetry = useThingsToDoTelemetry();
  const { t } = useTranslation('guestSiteCustom');
  const { constructCampaignUrl } = useThingToDo();
  const { accentColor } = useColorPaletteProvider();

  const handleTileClick = () => {
    telemetry.thingsToDoCTAClicked(props.url, {
      componentName: 'ThingToDoLink',
      url: props.url,
      thingToDoName: props.title,
      city: props.location,
      tours: props.tours,
    });

    window.open(constructCampaignUrl(props.url), '_blank', 'noopener');
  };

  return (
    <ThingToDoTile
      onClick={props.tours && props.tours.length > 0 ? undefined : handleTileClick}
      FooterContent={
        props.tours &&
        props.tours.length > 0 && (
          <Box marginTop={pxToRem(16)}>
            <TextV2
              typographyVariant="label2"
              marginBottom={pxToRem(12)}
            >
              {t('thingsToDo', 'interestingTours')()}
            </TextV2>
            <Flex
              flexDirection="column"
              gap={pxToRem(10)}
              paddingBottom={pxToRem(8)}
            >
              {props.tours.map(tour => (
                <TextV2
                  key={`tour-${tour.id}`}
                  as="a"
                  href={constructCampaignUrl(tour.url)}
                  target="_blank"
                  rel="noopener sponsored nofollow"
                  typographyVariant="label2"
                  color={accentColor ?? '#FFAE00'}
                  style={{ textDecoration: 'underline', cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                  onClick={() => {
                    telemetry.thingsToDoTourClicked(tour.url, {
                      componentName: 'ThingToDoLink',
                      url: tour.url,
                      thingToDoName: tour.title,
                      city: props.location,
                    });
                  }}
                >
                  {tour.title}
                </TextV2>
              ))}
            </Flex>
          </Box>
        )
      }
      {...props}
    />
  );
};
